<script lang="ts" setup>
import Message from './components/common/message/index.vue';
import { onMounted } from 'vue';
import useCommonStore from './store/common';
const commonStore = useCommonStore();
onMounted(() => {
  let isMobile = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  if (isMobile) {
    const loc = window.location;
    window.location.href = loc.href.replace(loc.host, 'm.zeepr.io');
  }
});
</script>
<template>
  <router-view />
  <Message />
</template>
